<template>
  <span>{{ timeAgo }}</span>
</template>

<script>
import dayjs from 'dayjs'

export default {
  name: 'TimeAgo',
  props: {
    justNowText: {
      type: String,
      default: ''
    },
    prefixText: {
      type: String,
      default: ''
    },
    date: {
      type: String,
      required: true
    }
  },
  computed: {
    dateInstance() {
      return dayjs(this.date)
    },
    timeAgo() {
      const now = dayjs()
      const diff = now.diff(this.dateInstance, 'minutes')

      if (diff >= 2) {
        return dayjs(this.date).fromNow()
      } else {
        return this.justNowText
      }
    }
  },
  mounted() {
    this.interval = setInterval(this.onTick.bind(this), 1000)
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  methods: {
    onTick() {
      this.$forceUpdate()
    }
  }
}
</script>
